import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { paths } from 'src/paths';
import { tokens } from 'src/locales/tokens';
import { lngRole } from 'src/locales/sys_strings';
import SvgIcon from '@mui/material/SvgIcon';
import { useCurrentRole } from 'src/hooks/use-auth';

import { prototypeSections } from 'src/routes/prototype/_config';
import { adminSections } from 'src/routes/configs/admin/config';
import { teacherSections } from 'src/routes/configs/teacher/config';
import { officerSections } from 'src/routes/configs/officer/config';
import { accountantSections } from 'src/routes/configs/accountant/config';
import { leaderSections } from 'src/routes/configs/leader/config';
import { sellerSections } from 'src/routes/configs/seller/config';
import { censorSections } from 'src/routes/configs/censor/config';
import { showLog } from 'src/utils/debug-log';
import { useMenus } from './use-privileges';

export const useSections = () => {
  const { t } = useTranslation();
  const currentRole = useCurrentRole();
  const menuPerms = (type) => { return useMenus(type); };

  const sections = useMemo(() => {
    if (currentRole) {
      if (currentRole === lngRole.teacher) {
        return teacherSections(t, tokens, paths, SvgIcon);
      }
      if (currentRole === lngRole.officer) {
        return officerSections(t, tokens, paths, SvgIcon, menuPerms('officer'));
      }
      if (currentRole === lngRole.accountant) {
        return accountantSections(t, tokens, paths, SvgIcon);
      }
      if (currentRole === lngRole.leader) {
        return leaderSections(t, tokens, paths, SvgIcon, menuPerms('leader'));
      }
      if (currentRole === lngRole.administrator) {
        return adminSections(t, tokens, paths, SvgIcon);
      }
      if (currentRole === lngRole.seller) {
        return sellerSections(t, tokens, paths, SvgIcon);
      }
      if (currentRole === lngRole.censor) {
        return censorSections(t, tokens, paths, SvgIcon);
      }
      if (currentRole === lngRole.highest) {
        return prototypeSections(t, tokens, paths, SvgIcon);
      }
    }
    return [];
  }, [currentRole, t]);

  const current = useMemo(() => {
    showLog('currentRole:', currentRole);
    return currentRole;
  }, [currentRole]);

  return useMemo(
    () => ({
      rolecode: current,
      sections: sections,
    }),
    [current, sections],
  );
};
